import { Injectable } from "@angular/core";
import Swal from "sweetalert2";
import { UtilsService } from "./utils.service";
import { GlobalsService } from "./globals.service";

class FunctionLockModel {
	uuid: string;
	functionKey: string;
	infiniteLoopCheck: number = 100;
	promise: Promise<void>;
	lockCount: number;
	intervalId: NodeJS.Timer;
}

@Injectable()
export class FunctionLockService {
	private functionLocks: any = {};

	constructor() {}

	lock(functionKey: string, iterationTimeout: number = 200): Promise<void> {
		if (!this.functionLocks[functionKey])
			this.functionLocks[functionKey] = [];

		const  functionLock = new FunctionLockModel();
		functionLock.functionKey = functionKey;
		functionLock.uuid = UtilsService.newGuid();
		functionLock.lockCount = this.functionLocks[functionKey].length + 1;
		functionLock.promise = new Promise<void>((resolve, reject) => {
			functionLock.intervalId = setInterval(() => {
				if (functionLock.lockCount === 1 || functionLock.infiniteLoopCheck-- === 0) {
					clearInterval(functionLock.intervalId);
					if (GlobalsService.isDebug) {
						if (functionLock.infiniteLoopCheck === 0) {
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: `Inifite loop detected for ${functionLock.functionKey}`,
								confirmButtonColor: '#007bff',
								heightAuto: false
							});
						}
					}
					resolve();
				}
			}, iterationTimeout);
		});

		
		this.functionLocks[functionKey].push(functionLock);

		return functionLock.promise;
	}

	release(functionKey: string): number {
		this.functionLocks[functionKey].splice(0, 1);
		this.functionLocks[functionKey].forEach((fl: FunctionLockModel) => fl.lockCount--);

		return this.functionLocks[functionKey].length;
	}
	
}

